import { render, staticRenderFns } from "./NeedToTurnDone.vue?vue&type=template&id=23434001&"
import script from "./NeedToTurnDone.vue?vue&type=script&lang=js&"
export * from "./NeedToTurnDone.vue?vue&type=script&lang=js&"
import style0 from "./NeedToTurnDone.vue?vue&type=style&index=0&id=23434001&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports